import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { UILanguage } from '~types/types';

// Import translations directly - single source of truth
import translationsFi from './locales/fi/translations.json';
import translationsEn from './locales/en/translations.json';

const resources = {
  fi: { translations: translationsFi },
  en: { translations: translationsEn }
};

i18n.use(initReactI18next).init({
  lng: UILanguage.Fi,
  fallbackLng: UILanguage.Fi,
  ns: ['translations'],
  defaultNS: 'translations',
  resources,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false // not needed for react!!
  }
});

export default i18n;
